// NOTE: This file will be imported in the frontend and `init` function will be called after DOM loaded.
// NOTE: Note that in the frontend any DOM nodes can be removed/inserted dynamically,
// NOTE:   so please don't rely on nodes other than body/document/window.
//
// NOTE: Also, you can provide some functions that can be used by frontend devs if needed.

import { isMobile } from "./components/is-mobile";
import { initAnimations } from "./components/animations";
import { vhCorrector } from "./components/vh-corrector";
import { isTouch } from "./components/is-touch";
import { gsap } from "./components/gsap";
import { hideMainScroll } from "./components/hide-main-scroll";
import { headerHeight } from "./components/header-height"; // replaced to header.js
import { sliceToLetters } from "./components/slice-to-letters";
import { bgText } from "./components/bg-text";

const init = () => {
    // It should work well with vue because it tracks a new DOM nodes too.
    initAnimations();

    window.addEventListener("resize", () => {
        vhCorrector();
        // headerHeight();
        bgText();
    });

    document.body.className += isTouch ? " touch" : " no-touch";

    vhCorrector();
    headerHeight();
    bgText();
};

export const staticLib = {
    isTouch,
    isMobile,
    init,
    gsap,
    hideMainScroll,
    sliceToLetters,
    headerHeight,
    bgText
};
